import { useToggleState } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import { useEffect, type PropsWithChildren } from "react";
import { CustomButton, CustomToggleBox } from "./toggleMenu.style";

export const ToggleMenu = ({ children }: PropsWithChildren) => {
    const [isMenu, setIsMenu] = useToggleState();
    const { isMobile } = MEDIA();

    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
        document.body.style.overflow = "auto";
    };

    useEffect(() => {
        if (isMenu) {
            disableScroll();
        } else {
            enableScroll();
        }

        return () => enableScroll();
    }, [isMenu]);

    return (
        <Center>
            <CustomButton
                size={isMobile ? "small" : "medium"}
                iconNamed="drag_indicator"
                border="none"
                onClick={() => setIsMenu((prev) => !prev)}
                className={isMenu ? "on" : "off"}
            >
                All Menu
            </CustomButton>
            <CustomToggleBox className={isMenu ? "on" : "off"}>{children}</CustomToggleBox>
        </Center>
    );
};
